import { useReactFlow } from '@xyflow/react'
import { useCallback } from 'react'
import type { SubscriptionHandler } from 'urql'

import type { MapEventsSubscription } from '@graphql/queries'
import { useMapEventsSubscription } from '@graphql/queries'

type UseMapEvents = (strategyId: string | null) => void

const useMapEvents: UseMapEvents = (strategyId) => {
  const { fitView } = useReactFlow()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handler: SubscriptionHandler<MapEventsSubscription, any> = useCallback(
    (_acc, result) => {
      const event = result?.mapEvents?.event

      if (event === 'FIT_VIEW') {
        return fitView({ padding: 0.2, includeHiddenNodes: true })
      }
    },
    [fitView]
  )

  useMapEventsSubscription(
    {
      variables: {
        strategyId
      },
      pause: !strategyId
    },
    handler
  )
}

export default useMapEvents
